/**
 * @module root/validations/messages
 */

import { i18n } from "@/services/i18n";
import _ from "lodash";
/* eslint-disable sonarjs/cognitive-complexity*/

/**
 * Returns an array of error messages for the failed validators on model.
 *
 * @author CH-E01365 -Davinder Singh
 * @export
 * @param {*} validator The leaf validator model (e.g:  $v.form.email)
 * @param {string} fieldTranslationKey The translation key to use for constructing error messages (Label for field).
 * @returns
 */
export default function commonMessages(
  validator: any,
  fieldTranslationKey: string
) {
  const errors: Array<string> = [];
  if (!validator.$dirty) return errors;

  fieldTranslationKey = i18n.t(fieldTranslationKey) as string;
  fieldTranslationKey=fieldTranslationKey.split(' ').map(_.capitalize).join(' ');
  if (validator.hasOwnProperty("required") && !validator.required) {
    errors.push(i18n.t("validations.required", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("alpha") && !validator.alpha) {
    errors.push(i18n.t("validations.alpha", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("alphaSpace") && !validator.alphaSpace) {
    errors.push(i18n.t("validations.alphaSpace", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("alphaNum") && !validator.alphaNum) {
    errors.push(i18n.t("validations.alphaNum", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("numeric") && !validator.numeric) {
    errors.push(i18n.t("validations.numeric", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("minLength") && !validator.minLength) {
    errors.push(i18n.t("validations.minLength", {
      field: fieldTranslationKey,
      length: validator.$params.minLength.min
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("maxLength") && !validator.maxLength) {
    errors.push(i18n.t("validations.maxLength", {
      field: fieldTranslationKey,
      length: validator.$params.maxLength.max
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("minValue") && !validator.minValue) {
    errors.push(i18n.t("validations.minValue", {
      field: fieldTranslationKey,
      value: validator.$params.minValue.min
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("maxValue") && !validator.maxValue) {
    errors.push(i18n.t("validations.maxValue", {
      field: fieldTranslationKey,
      value: validator.$params.maxValue.max
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("date") && !validator.date) {
    errors.push(i18n.t("validations.date", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("sameAs") && !validator.sameAs) {
    errors.push(i18n.t("validations.sameAs", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }
  if (validator.hasOwnProperty("email") && !validator.email) {
    errors.push(i18n.t("validations.email", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }
  if (validator.hasOwnProperty("pan") && !validator.pan) {
    errors.push(i18n.t("validations.pan", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("customPattern") && !validator.customPattern) {
    errors.push(i18n.t("validations.valid", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("ifsc") && !validator.ifsc) {
    errors.push(i18n.t("validations.ifsc", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("aadhaar") && !validator.aadhaar) {
    errors.push(i18n.t("validations.aadhaar", {
      field: fieldTranslationKey
    }) as string);
    return errors;
  }

  if (validator.hasOwnProperty("fileType") && !validator.fileType) {
    errors.push(i18n.t("validations.fileType", {
      field: fieldTranslationKey,
      types: validator.$params.fileType.extns.join(", ")
    }) as string);
    return errors;
  }
  return errors;
}